import { useState, useEffect, useMemo } from 'react';

const PAGE_SIZE = 20;

export const useDetailSort = (data) => {
  const [sortKey, setSortKey] = useState(null);
  const [asc, setAsc] = useState(true);
  const [page, setPage] = useState(1);

  useEffect(() => { setPage(1); }, [data]);

  const handleSort = (key) => {
    if (sortKey === key) setAsc(a => !a);
    else { setSortKey(key); setAsc(true); }
    setPage(1);
  };

  const sorted = useMemo(() => {
    if (!sortKey || !data?.length) return data || [];
    return [...data].sort((a, b) => {
      const av = a[sortKey], bv = b[sortKey];
      if (typeof av === 'number' && typeof bv === 'number') return asc ? av - bv : bv - av;
      return asc
        ? String(av ?? '').localeCompare(String(bv ?? ''))
        : String(bv ?? '').localeCompare(String(av ?? ''));
    });
  }, [data, sortKey, asc]);

  const totalPages = Math.max(1, Math.ceil(sorted.length / PAGE_SIZE));
  const safePage   = Math.min(page, totalPages);
  const visible    = sorted.slice((safePage - 1) * PAGE_SIZE, safePage * PAGE_SIZE);

  return { visible, sortKey, asc, handleSort, page: safePage, setPage, totalPages, total: sorted.length };
};
